import { getContrastColorFromRGB } from "../helpers/contrastColor";

const vContrast = {
  inserted(el: HTMLElement) {
    const bg = getComputedStyle(el).backgroundColor;
    const rgbArray = bg.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/);

    if (rgbArray != null && rgbArray.length >= 4) {
      const r = parseInt(rgbArray[1], 10);
      const g = parseInt(rgbArray[2], 10);
      const b = parseInt(rgbArray[3], 10);
      const textColor = getContrastColorFromRGB(r, g, b);
      el.style.color = textColor;
    }
  },
};

export default vContrast;